module.exports = __webpack_public_path__ + "img/cesVolume.ec53652b.png";